// Force dropdown selects to fill their container width
(function() {
  console.log('[Dropdown Fix] Script loaded');

  function fixDropdownWidth() {
    const dropdownRows = document.querySelectorAll('.tda-customizer-customization-option:has(.tda-customizer-dropdown-customization-option-value-list)');

    if (dropdownRows.length === 0) {
      console.log('[Dropdown Fix] No dropdown rows found, retrying...');
      setTimeout(fixDropdownWidth, 500);
      return;
    }

    console.log('[Dropdown Fix] Found', dropdownRows.length, 'dropdown rows');

    dropdownRows.forEach((row, index) => {
      const dropdownList = row.querySelector('.tda-customizer-dropdown-customization-option-value-list');
      if (dropdownList) {
        const select = dropdownList.querySelector('select');
        if (select) {
          // Get the actual width of the dropdown list container
          const containerWidth = dropdownList.getBoundingClientRect().width;

          console.log(`[Dropdown Fix] Row ${index + 1} - Container width: ${containerWidth}px`);

          // Set the select to match the container width exactly
          select.style.setProperty('width', `${containerWidth}px`, 'important');
          select.style.setProperty('max-width', 'none', 'important');
          select.style.setProperty('min-width', `${containerWidth}px`, 'important');
          select.style.removeProperty('flex');
          select.style.removeProperty('flex-grow');
          select.style.removeProperty('flex-shrink');
          select.style.removeProperty('flex-basis');

          console.log(`[Dropdown Fix] Set select to ${containerWidth}px width`);
        }
      }
    });

    // Re-calculate and apply width on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        dropdownRows.forEach((row) => {
          const dropdownList = row.querySelector('.tda-customizer-dropdown-customization-option-value-list');
          if (dropdownList) {
            const select = dropdownList.querySelector('select');
            if (select) {
              const containerWidth = dropdownList.getBoundingClientRect().width;
              select.style.setProperty('width', `${containerWidth}px`, 'important');
              select.style.setProperty('min-width', `${containerWidth}px`, 'important');
            }
          }
        });
      }, 100);
    });

    // Watch for DOM changes and reapply
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        dropdownRows.forEach((row) => {
          const dropdownList = row.querySelector('.tda-customizer-dropdown-customization-option-value-list');
          if (dropdownList) {
            const select = dropdownList.querySelector('select');
            if (select) {
              const containerWidth = dropdownList.getBoundingClientRect().width;
              const currentWidth = select.getBoundingClientRect().width;

              // Only update if different
              if (Math.abs(currentWidth - containerWidth) > 1) {
                select.style.setProperty('width', `${containerWidth}px`, 'important');
                select.style.setProperty('min-width', `${containerWidth}px`, 'important');
                console.log('[Dropdown Fix] Re-applied width after mutation');
              }
            }
          }
        });
      }, 50);
    });

    // Observe each dropdown row
    dropdownRows.forEach((row) => {
      observer.observe(row, { childList: true, subtree: true, attributes: true });
    });
  }

  // Run after DOM loads and Angle 3D renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(fixDropdownWidth, 1500));
  } else {
    setTimeout(fixDropdownWidth, 1500);
  }
})();
